var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_767_4652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7076 15.3453C29.7076 14.3257 29.6249 13.3005 29.4485 12.2974H15.3V18.0736H23.4022C23.066 19.9365 21.9857 21.5845 20.4039 22.6317V26.3797H25.2376C28.0761 23.7671 29.7076 19.909 29.7076 15.3453Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3 30.0012C19.3456 30.0012 22.7573 28.6728 25.2431 26.38L20.4093 22.6321C19.0645 23.547 17.3283 24.0651 15.3055 24.0651C11.3922 24.0651 8.07421 21.425 6.88369 17.8755H1.89563V21.7392C4.44202 26.8044 9.6285 30.0012 15.3 30.0012V30.0012Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87822 17.8754C6.24989 16.0124 6.24989 13.9952 6.87822 12.1322V8.26855H1.89568C-0.231827 12.507 -0.231827 17.5006 1.89568 21.7391L6.87822 17.8754V17.8754Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3 5.93708C17.4385 5.90401 19.5054 6.70871 21.0542 8.18583L25.3367 3.90327C22.625 1.35688 19.0259 -0.0430825 15.3 0.00101083C9.6285 0.00101083 4.44202 3.19778 1.89563 8.26851L6.87818 12.1322C8.06318 8.57716 11.3867 5.93708 15.3 5.93708V5.93708Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_767_4652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.0e3d8239f86c924814a958f3b31f51ad.svg";
export { ForwardRef as ReactComponent };